export const blanco = "#fff";
export const negro = "#000000";
export const fondoNegro = "#fff";
export const azul = "#fff";
export const fondo = "#fff";
export const gris1 = "#fff";
export const gris2 = "#fff";
export const gris3 = "#fff";
export const rojo = "#fff";
export const rojoClaro = "#fff";
export const rojoOscuro = "#fff";